import { Link } from 'react-router-dom';
import { useFormSubmit } from '@/hooks/useFormSubmit';

const SUBSCRIBE_URL = 'https://readdy.ai/api/form/db7501raskivmpnrcg00';

const footerLinks = [
  { to: '/category/news', label: '娱乐资讯' },
  { to: '/category/video', label: '热门视频' },
  { to: '/category/topic', label: '互动话题' },
  { to: '/special', label: '精选专题' },
  { to: '/search', label: '全站搜索' },
  { to: '/about', label: '关于我们' },
];

export default function Footer() {
  const { status, message, submit } = useFormSubmit(SUBSCRIBE_URL, '订阅成功，娱乐速报会第一时间送达你的邮箱！');

  return (
    <footer className="w-full bg-secondary-900 text-background-100 mt-16 md:mt-24">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-xl">
                艹
              </span>
              <span className="font-heading text-2xl">一起艹</span>
            </div>
            <p className="mt-4 text-sm text-secondary-200 max-w-md leading-relaxed">
              一起艹是面向娱乐爱好者的内容聚合平台，聚合最新娱乐资讯、精选视频与互动话题，
              让每一次打开都遇见有趣的内容。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['娱乐资讯', '精选视频', '互动话题', '专题策划'].map((tag) => (
                <span key={tag} className="px-3 py-1 rounded-full bg-secondary-800 text-xs text-secondary-100">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-lg text-background-50 mb-4">快速导航</h3>
            <ul className="grid grid-cols-2 gap-y-3 gap-x-4">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-secondary-200 hover:text-accent-400 cursor-pointer transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-heading text-lg text-background-50 mb-4">订阅娱乐速报</h3>
            <p className="text-sm text-secondary-200 mb-4">每周精选娱乐资讯与热门内容，一键送达。</p>
            <form
              id="subscribe-form"
              data-readdy-form
              onSubmit={(event) => {
                event.preventDefault();
                submit(event.currentTarget);
              }}
              className="flex flex-col sm:flex-row gap-3"
            >
              <input
                type="text"
                name="company_alt"
                className="form-honeypot-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <input
                type="email"
                name="email"
                required
                placeholder="请输入你的邮箱"
                className="flex-1 h-11 px-4 rounded-md bg-secondary-800 border border-secondary-700 text-sm text-background-50 placeholder:text-secondary-400 outline-none focus:border-primary-400"
              />
              <button
                type="submit"
                disabled={status === 'submitting'}
                className="h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 whitespace-nowrap cursor-pointer disabled:opacity-60 transition-colors"
              >
                {status === 'submitting' ? '提交中…' : '立即订阅'}
              </button>
            </form>
            {message ? (
              <p className={`mt-3 text-sm ${status === 'success' ? 'text-accent-400' : 'text-primary-300'}`}>{message}</p>
            ) : null}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-secondary-300">
          <p>© 2026 一起艹 · 优质娱乐休闲内容聚合平台 · 本站内容均为虚构演示数据</p>
          <p className="flex items-center gap-4">
            <span>联系邮箱：hello@yiqicao.demo</span>
            <span className="hidden sm:inline">·</span>
            <span>仅供学习演示</span>
          </p>
        </div>
      </div>
    </footer>
  );
}